import { ErrorComponent } from "../../components";

export default function NotFoundPage() {
  return <ErrorComponent.NotFoundPage />;
}
